module.exports = "/lucky-balls/img/bigball/BigBall_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_008.png
// module id = 903
// module chunks = 0